import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { Button, Flex, Input, Select } from "antd";
import style from "../../organisms/doctorConsult/doctorConsult.module.scss"
import { usePaymentLink } from "../../../hooks/usePaymentLink/usePaymentLink";
import './PaymentLink.css';


export const PaymentLink = ({ component }: any) => {
    const { amount, error, number, handleSendPaymentLink, email, handleCollectMobileNumber, handleCollectEmail, handleCatchAmount,
        handleSelectChange, benList, isLoading,
        ambulanceType, isEditable, handleAmountBlur, handleAmountEditing, handleAmbulanceTypeChange, selectedDetails, selectedAmbulanceRateCard, doctorId, doctorPayment, handleAmountEditingForDoctor, handleCatchAmountForDoctor, pocorateCard, handleRateCardrChange, selectedPocoRateCard } = usePaymentLink({ component });
    const isAmbulanceFlow = component === "Ambulance";
    return (
        <Container>
            {isAmbulanceFlow ?
                <Flex vertical gap={12}>
                    <Select
                        value={selectedPocoRateCard}
                        options={pocorateCard.map((provider: any) => ({
                            label: provider.rateCardName,
                            value: provider.rateCardName,
                        }))}
                        placeholder="Select Ambulance Provider"
                        style={{ width: "100%" }}
                        size="middle"
                        onChange={handleRateCardrChange}
                    />

                    <Select
                        value={ambulanceType}
                        options={selectedAmbulanceRateCard[0]?.ambulanceTypes ? selectedAmbulanceRateCard[0].ambulanceTypes.map((type: string) => ({
                            label: type,
                            value: type,
                        })) : []}
                        placeholder="Select Ambulance Type"
                        style={{ width: "100%" }}
                        size="middle"
                        onChange={handleAmbulanceTypeChange}
                    />

                    <Input
                        value={amount ? '₹ ' + amount : ''}
                        allowClear={true}
                        placeholder="₹ Ambulance Fare"
                        onChange={handleCatchAmount}
                        maxLength={10}
                        onClick={handleAmountEditing}
                        onDoubleClick={handleAmountEditing}
                        onBlur={handleAmountBlur}
                        readOnly={!isEditable}
                        className={isEditable ? 'input-focused' : 'input-blurred'}
                    />
                    <Select
                        mode="tags"
                        size={"middle"}
                        placeholder="Please select Benificiary"
                        style={{ width: '100%' }}
                        options={benList.map((elem) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                        onChange={handleSelectChange}
                        maxCount={1}
                        allowClear={true}
                        value={selectedDetails.map((elem: any) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                    >
                    </Select>
                    <Flex justify="center" >
                        <Text text="or" />
                    </Flex>
                    <Input value={number || ""} allowClear={true} onChange={handleCollectMobileNumber} maxLength={10} placeholder="Please Enter Mobile" />
                    <Flex justify="center" >
                        <Text text="Optional" />
                    </Flex>
                    <Input status={error ? 'error' : ''} type="email" value={email || ""} allowClear={true} onChange={handleCollectEmail} placeholder="Please Enter Email" />
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                    <Button className={style.link_btn} loading={isLoading} onClick={handleSendPaymentLink}>Send Payment Link</Button>
                </Flex> :

                //      Drop down for doctor consultation fee payment

                <Flex vertical gap={12}>
                    {/* // selection of Ambulance Provider */}
                    {/* options={ambulanceProvidersList.map((provider: any) => ({ label: provider.name, value: provider.id }))} */}
                    <Input value={doctorId}
                        allowClear={true}
                        readOnly={true}
                    />

                    <Input value={doctorPayment}
                        allowClear={true}
                        maxLength={10}
                        onChange={handleCatchAmountForDoctor}
                        onDoubleClick={handleAmountEditingForDoctor}
                        onBlur={handleAmountBlur}
                        readOnly={!isEditable}
                        className={isEditable ? 'input-focused' : 'input-blurred'}
                    />

                    <Select
                        mode="tags"
                        size={"middle"}
                        placeholder="Please select"
                        style={{ width: '100%' }}
                        options={benList.map((elem) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                        onChange={handleSelectChange}
                        maxCount={1}
                        allowClear={true}
                        value={selectedDetails.map((elem: any) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                    >
                    </Select>
                    <Flex justify="center" >
                        <Text text="or" />
                    </Flex>
                    <Input value={number || ""} allowClear={true} onChange={handleCollectMobileNumber} maxLength={10} placeholder="Please Enter Mobile" />
                    <Flex justify="center" >
                        <Text text="Optional" />
                    </Flex>
                    <Input status={error ? 'error' : ''} type="email" value={email || ""} allowClear={true} onChange={handleCollectEmail} placeholder="Please Enter Email" />
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                    <Button className={style.link_btn} loading={isLoading} onClick={handleSendPaymentLink}>Send Payment Link</Button>
                </Flex>
            }

        </Container>
    );
}